/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.0.1
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const DistanceUnit = {
  Km: "km",
  Mi: "mi",
} as const;
export type DistanceUnit = (typeof DistanceUnit)[keyof typeof DistanceUnit];

export function instanceOfDistanceUnit(value: any): boolean {
  for (const key in DistanceUnit) {
    if (Object.prototype.hasOwnProperty.call(DistanceUnit, key)) {
      if (DistanceUnit[key as keyof typeof DistanceUnit] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DistanceUnitFromJSON(json: any): DistanceUnit {
  return DistanceUnitFromJSONTyped(json, false);
}

export function DistanceUnitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DistanceUnit {
  return json as DistanceUnit;
}

export function DistanceUnitToJSON(value?: DistanceUnit | null): any {
  return value as any;
}

export function DistanceUnitToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DistanceUnit {
  return value as DistanceUnit;
}
